// extracted by mini-css-extract-plugin
export default {"root":"IconBell_root__1VjeS","fillColor":"IconBell_fillColor__0OuA5"};